import { render, staticRenderFns } from "./estudiosComponent.vue?vue&type=template&id=124974e8&"
import script from "./estudiosComponent.vue?vue&type=script&lang=js&"
export * from "./estudiosComponent.vue?vue&type=script&lang=js&"
import style0 from "./estudiosComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports